import { handleActions, createAction } from 'redux-actions';
import { createFormAction } from 'redux-form-saga';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'CREATE_CAPABILITY',
    'FETCH_CAPABILITY_LIST',
    'FETCH_CAPABILITY_LIST_SUCCESS',
    'FETCH_CAPABILITY',
    'FETCH_CAPABILITY_SUCCESS',
    'UPDATE_CAPABILITY',
], 'CAPABILITY');

// Action Creators
export const createCapabilityForm = createFormAction(actions.CREATE_CAPABILITY);
export const updateCapabilityForm = createFormAction(actions.UPDATE_CAPABILITY);
export const fetchList = createAction(actions.FETCH_CAPABILITY_LIST);
export const fetchListSuccess = createAction(actions.FETCH_CAPABILITY_LIST_SUCCESS);
export const fetchCapability = createAction(actions.FETCH_CAPABILITY);
export const fetchCapabilitySuccess = createAction(actions.FETCH_CAPABILITY_SUCCESS);

// Reducers
const initialState = {
    list: [],
    listFetched: false,
    capabilityGroup: null
};

export default handleActions({
    [actions.FETCH_CAPABILITY_LIST_SUCCESS]: (state, action) => {
        const updatedData = {
            list: { $set: action.payload },
            listFetched: { $set: true }
        };
        return update(state, updatedData);
    },
    [actions.FETCH_CAPABILITY_SUCCESS]: (state, action) => {
        const updatedData = {
            capabilityGroup: { $set: action.payload }
        };
        return update(state, updatedData);
    }
}, initialState);



// WEBPACK FOOTER //
// ./src/services/capabilities/duck.js